
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/international/results",
      function () {
        return require("private-next-pages/flights/international/results/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights/international/results"])
      });
    }
  